import Card from '@/components/Card';
import Stack from '@/components/Stack';
import { Body, Small } from '@/components/Typography';
import Badge from '@/components/Badge';
import { WorkExperience } from '@/services/workersV2API';

type Props = {
  workExperiences: WorkExperience[];
};

const formatDate = (dateString: string | null) => {
  if (!dateString) return 'Present';
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
};

const formatDuration = (months: number | null) => {
  if (!months || months === 0) return 'Less than 1 month';
  if (months < 12) return `${months} month${months !== 1 ? 's' : ''}`;

  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  if (remainingMonths === 0) {
    return `${years} year${years !== 1 ? 's' : ''}`;
  }

  return `${years} year${years !== 1 ? 's' : ''} ${remainingMonths} month${remainingMonths !== 1 ? 's' : ''}`;
};

const WorkExperiencesCard = ({ workExperiences }: Props) => {
  if (!workExperiences || workExperiences.length === 0) {
    return (
      <Card title="Work Experience (0)">
        <Card.Section>
          <Stack style={{ justifyContent: 'center', padding: '20px' }}>
            <Small color="lighter">No work experience found</Small>
          </Stack>
        </Card.Section>
      </Card>
    );
  }

  return (
    <Card title={`Work Experience (${workExperiences.length})`}>
      {workExperiences.map((exp) => (
        <Card.Section key={exp.id}>
          <Stack vertical gap={12}>
            <Stack
              style={{
                justifyContent: 'space-between',
                alignItems: 'flex-start',
              }}
            >
              <Stack vertical gap={4}>
                <Body weight="semibold">{exp.company_name}</Body>
                <Small color="lighter">
                  {formatDate(exp.start_date)} - {formatDate(exp.end_date)}
                </Small>
              </Stack>
              {exp.is_staffing_agency && (
                <Badge label="Staffing Agency" status="theme" />
              )}
            </Stack>

            <Stack
              style={{
                padding: '12px',
                backgroundColor: '#F9FAFB',
                borderRadius: '6px',
              }}
            >
              <Stack gap={8} style={{ alignItems: 'center' }}>
                <Small weight="semibold">Duration:</Small>
                <Small>{formatDuration(exp.duration_months)}</Small>
              </Stack>
            </Stack>

            <Small color="lighter">Added: {formatDate(exp.created_at)}</Small>
          </Stack>
        </Card.Section>
      ))}
    </Card>
  );
};

export default WorkExperiencesCard;
